export const MODULE = {
  ASSIGNED_CARD_LIST: 'ASSIGNED_CARD_LIST',
  MANAGED_CARD_LIST: 'MANAGED_CARD_LIST',
  CARD_MANAGING_ACCOUNT_LIST: 'CARD_MANAGING_ACCOUNT_LIST',
  NOTIFICATION_SETTING: 'NOTIFICATION_SETTING',
  ELECTRONIC_WALLET: 'ELECTRONIC_WALLET',
  TICKET_FARE: 'TICKET_FARE',
};
